import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { NavigationItem } from '../PrimaryTabs'
import SubNavigationMenuItem from './SubNavigationMenuItems'

interface SubMenuExpandedProps {
  menuItem: NavigationItem
  isExpanded: boolean
}

const SubMenuExpanded = ({ menuItem, isExpanded }: SubMenuExpandedProps) => {
  return (
    <AnimatePresence>
      {isExpanded && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{
            type: 'spring',
            stiffness: 550,
            damping: 38,
            mass: 1,
            duration: 0.2
          }}
          className='flex pl-2 w-full overflow-hidden'
        >
          <div className='flex flex-col items-center justify-center gap-2 min-w-5 self-stretch '>
            <div className='w-[1.5px] h-full mx-auto bg-gradient-to-b from-gray-400/40 via-gray-400/20 to-transparent'></div>
          </div>
          <motion.div layout className='w-full mb-2 flex flex-col'>
            {menuItem.children!.map(subMenuItem => (
              <SubNavigationMenuItem key={subMenuItem.title} subMenuItem={subMenuItem} />
            ))}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default SubMenuExpanded
